import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import StoreNoteGrid from '../../../features/cfi/notes/components/StoreNoteGrid';
import {KindOfOrder} from '../../../types/enums';

export default function WorkOrderNotesPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Work Order Notes')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<StoreNoteGrid kindOfOrder={KindOfOrder.WorkOrder} />
			</div>
		</React.Fragment>
	)
} 
